import React, { useState, useEffect } from "react";
import ReactIdSwiper from "react-id-swiper";
import * as actions from '../Actions';
import ShareOptions from '../ShareOptions';

export default (props) => {
  // //console.log(props);
  var data = props.data.data;
  var feedItem = props.data;
  // Swiper instance
  const [swiper, updateSwiper] = useState(null);
  // Slides current index
  const [currentIndex, updateCurrentIndex] = useState(0);
  var elePagi = ".swiper-pagination";
  if (props.page == "home-banners") {
    elePagi = ".swiper-pagination.swiper-pagination-white";
  }
  var params = {};
  // Params definition
if (props.page == "dr-carousel-unit") {
  const slidesCount = data.length;
  params = {
    loop: false,
    slidesPerView: slidesCount === 1 ? 1.1 : 1.7,
    spaceBetween: slidesCount === 1 ? 15 : 15,
    breakpoints: {
      767: {
        slidesPerView: slidesCount === 1 ? 1.1 : 1.1,
        spaceBetween: slidesCount === 1 ? 12 : 12
      },
    },
    getSwiper: updateSwiper // Get swiper instance callback
  };
}
  

  // Manipulate swiper from outside
  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  // Add eventlisteners for swiper after initializing
  useEffect(() => {
    if (swiper !== null) {
      swiper.on("slideChange", () => updateCurrentIndex(swiper.realIndex));
    }

    return () => {
      if (swiper !== null) {
        swiper.off("slideChange", () => updateCurrentIndex(swiper.realIndex));
      }
    };
  }, [swiper]);

  return (
    <div>
      <ReactIdSwiper {...params}>
        {data.map((item, idx) => (
          (props.page == "dr-carousel-unit" ?
            <div className="swiper-slide_feed " key={idx}>
                <div className="new_artical_baby_week_main_content">
                     <div className="new_born_opacity" data-id={item.articleId} data-title={item.articleTitle}>
                     <a id="gtm-hightlightweek" className="gtm-hightlightweek" href={(item.articleUrl)?item.articleUrl:'#'}>
                       <img src={(item.articleImage)?item.articleImage:"https://cdn.cdnparenting.com/brainbees/community/preact/public/media/no-image.png"} onError={(e) => { e.target.src = "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/no-image.png"}} alt="logo" />
                      </a>
                     </div>
                     <div className="new_artical_name_content">
                        <div className="baby_name_text M18_white">{(item.articleTitle)?item.articleTitle:item.title}</div>
                     </div>
                </div>
                 <div className="baby-week-social-view hightlighted-social-view"> 
                 <div id="gtm-highlightitle" style={{ 'display': 'none' }}>  {(item.articleTitle)?item.articleTitle:item.title} </div>
                    <div className="post-options">
                      <div className="icon left devMemoLike font-sizeview R14_61" data-icon-font="$" > <span className="icons-text R13_61">{(item.viewCount)?item.viewCount:'0'}</span> </div>
                      <div className={`icon left  ${(item.isLiked?'active':'')}`} > 
                      <span className="icon R14_61 likesIcon gtm-highlight-like" data-icon-font="" onClick={(e) => actions.likeArticle(item.articleId, e, item.likeCount)}></span>
                      <span className="icons-text R13_61" onClick={(e) => actions.getAnswerLikeUsersArticle(e,item.articleId, item.likeCount)}>{item.likeCount} <span className='mLike'>Likes</span></span>

                      </div>
                    </div>
                    <div className="m-abuse-main right" id={`share_${item.articleId}`}>
                        <div className="icon left icon3dot facebookicons" data-icon-font="J"></div>
                        <div className="icon left icon3dot whatsapp-icons" data-icon-font=""> <span className="icons-text R14_61 cursor-pointer gtm-highlight-share" onClick={() => actions.shareOn(item.articleId)}> Share </span></div>
                        <ShareOptions feedItem={feedItem} eleRef={item} />
                    </div>
                </div>
            </div>
            :
            <div className="swiper-slide_feed" key={idx}>
              <img src="https://bbcdnlivemumbai.s3.ap-south-1.amazonaws.com/brainbees/community/memoryimages/1584339297p4706331.jpeg" />
            </div>
          )
        ))}
      </ReactIdSwiper>
      <div className="buttons buttons-list" style={{ display: "none" }}>
        <button id="prevSlide" className="button is-primary" onClick={goPrev}>
          Prev
        </button>
        <button id="nextSlide" className="button is-primary" onClick={goNext}>
          Next
        </button>
      </div>
    </div>
  );
};
